import React from 'react';

const Footer = () => (
    <div class="footer">
        Copyright 2022 © OSUNGSM all right reserved
    </div>
)

export default Footer;  